import dayjs from "dayjs";
import { cloneDeep } from "lodash";

import { ApiDealsRoutesItem } from "@/api/routes";

export const SORT_OPTIONS = [
  {
    value: 1,
    label: `Points: Low to High`,
    fn: (a: ApiDealsRoutesItem, b: ApiDealsRoutesItem) => {
      if (a.price < b.price) {
        return -1;
      }

      return 1;
    },
  },
  // {
  //   value: 2,
  //   label: `Points: high to low`,
  //   fn: (a: ApiDealsRoutesItem, b: ApiDealsRoutesItem) => {
  //     if (a.price > b.price) {
  //       return -1;
  //     }

  //     return 1;
  //   },
  // },
  {
    value: 3,
    label: `Date: Earliest to Latest`,
    fn: (a: ApiDealsRoutesItem, b: ApiDealsRoutesItem) => {
      if (dayjs(a.date).isBefore(b.date)) {
        return -1;
      }

      return 1;
    },
  },
  {
    value: 4,
    label: `Date: Latest to Earliest`,
    fn: (a: ApiDealsRoutesItem, b: ApiDealsRoutesItem) => {
      if (dayjs(a.date).isAfter(b.date)) {
        return -1;
      }

      return 1;
    },
  },
  {
    value: 5,
    label: `Last Seen`,
    fn: (a: ApiDealsRoutesItem, b: ApiDealsRoutesItem) => {
      if (a.ls > b.ls) {
        return -1;
      }

      return 1;
    },
  },
];

/**
 * 排序
 */
export const sortFn = (list: ApiDealsRoutesItem[], sortKey?: number): ApiDealsRoutesItem[] => {
  const targetSort = SORT_OPTIONS.find((item) => item.value === sortKey);
  return targetSort?.fn ? cloneDeep(list).sort(targetSort?.fn) : list;
};
